import Vue from 'vue'
const state = {
    id: 0,
    title: '',
    image: null,
    imageUpload: null,
    servings: 1,
    slug: '',
    notes: [],
    isPreview: false
}

const mutations = {
    SET_RECIPE (state, value) {
        state.imageUpload = null
        state = Object.assign(state, value)
    },
    SET_ID (state, value) {
        state.id = value
    },
    SET_SERVINGS (state, value) {
        state.servings = value
    },
    SET_NOTES (state, value) {
        state.notes = value
    },
    SET_TITLE (state, value) {
        state.title = value
    },
    SET_IMAGE_UPLOAD (state, data) {
        state.imageUpload = data
        // state.images[0][1].id = data.id
    },
    SET_PREVIEW (state, value) {
        state.isPreview = value
    },
}

const actions = {
    setRecipe ({commit, dispatch}, value) {
        commit('SET_RECIPE', value)
        let ingredient_lists = []
        let parent = 0;
        value.ingredient_lists.forEach(list => {
            let ingredients = []
            list.ingredients.forEach(ingredient => {
                let measures = []
                /*
                ingredient.raw.measures.forEach(measure => {
                    let m = {text: measure.name, value: measure}
                    if (measure.id) m.id = measure.id
                    measures.push(m)
                    if (ingredient.food_measure_id === measure.id && ingredient.measure_name === measure.name) {
                        ingredient.measure = m.value
                    }
                })

                ingredient.measures = measures
                if (!ingredient.measure) ingredient.measure = measures[0].value // default to gms
                 */
                ingredient.dirty = true
                ingredient.parent = parent
                ingredients.push(ingredient)
            })
            list.ingredients = ingredients
            ingredient_lists.push(list)
            parent++
        })
        dispatch('Ingredients/setIngredients', ingredient_lists, {root: true})

        let method_lists = []
        parent = 0;
        if(!value.method_lists) value.method_lists = []
        value.method_lists.forEach(list => {
            let methods = []
            list.methods.forEach(method => {
                method.dirty = true
                method.parent = parent
                methods.push(method)
            })
            list.methods = methods
            method_lists.push(list)
            parent++
        })
        dispatch('Methods/setMethods', method_lists, {root: true})
        //dispatch('loadShoppingList')
    },
    setId ({commit}, value) {
        commit('SET_ID', value)
    },
    setNotes ({commit}, value) {
        commit('SET_NOTES', value)
    },
    setServings ({commit}, value) {
        commit('SET_SERVINGS', value)
    },
    setTitle ({commit}, value) {
        commit('SET_TITLE', value)
    },
    setImageUpload ({commit}, value) {
        commit('SET_IMAGE_UPLOAD', value)
    },
    loadRecipe ({state, rootState, dispatch, commit}, value) {
        if (value < 1) {
            commit('SET_RECIPE', {
                id: 0,
                title: '',
                image: null,
                imageUpload: null,
                servings: 1,
                slug: '',
                notes: [
                    {stream: 0, text: ''}
                ],
            })

            dispatch('Ingredients/setIngredients', [{title: 'Ingredients', ingredients: []}], {root: true})
            dispatch('Methods/setMethods', [{title: 'Methods', methods: []}], {root: true})
            return
        }
        dispatch('Global/setLoading', true, {root: true})
        axios.post(rootState.Settings.apiUrl + '/recipe/load', {id: value})
            .then(function (response) {
                dispatch('setRecipe', response.data)
                dispatch('getImage')
                dispatch('Global/setLoading', false, {root: true})
            })
    },
    async saveRecipe ({state, rootState, dispatch}) {
        if(state.title.length < 1) return
        dispatch('Global/setSaving', true, {root: true})
        let recipe = state
        recipe.ingredient_lists = rootState.Ingredients.ingredient_lists
        recipe.method_lists = rootState.Methods.method_lists
        let data = new FormData()
        data.set('id', recipe.id)
        data.set('title', recipe.title)
        data.set('servings', recipe.servings)
        data.set('slug', recipe.slug)
        data.set('notes', JSON.stringify(recipe.notes))
        data.append('imageUpload', recipe.imageUpload)
        data.set('ingredient_lists', JSON.stringify(recipe.ingredient_lists))
        data.set('method_lists', JSON.stringify(recipe.method_lists))
        await axios.post(rootState.Settings.apiUrl + '/recipe/save', data)
            .then(function (response) {
                dispatch('setRecipe', response.data)
                dispatch('Global/setSaving', false, {root: true})
            })
    },
    async uploadImage ({state, rootState}, image) {

        var image = state.image

        image.status = 'loading'

        await axios.post('/recipes/upload-image',
            {image: image})
            .then(async function (response) {
                image.status = 'success'
                setTimeout(() => image.status = 'edit', 2000)
            })
            .catch(function (error) {
                throw error.response
            })
    },
    async getImage ({state, rootState, commit}) {
    },
    previewRecipe ({dispatch, commit}, value) {
        dispatch('loadRecipe', value)
        dispatch('setPreview', true)
    },
    setPreview ({commit}, value) {
        commit('SET_PREVIEW', value)
    },
    addNotesVariation({commit, state, rootState}) {
        let notes = state.notes
        notes.push({stream: rootState.Streams.stream.id, text: ''})
        commit('SET_NOTES', notes)
    }
}

const getters = {
    recipe: (state, getter, rootState) => {
        let recipe = state
        recipe.ingredient_lists = rootState.Ingredients.ingredient_lists
        return recipe
    },
    notes: (state, getter, rootState) => {
        if(!rootState.Streams) return {}

        let notes = state.notes.filter(note => note.stream === rootState.Streams.stream.id)
        if(notes.length > 0) notes = notes[0]
        else notes = state.notes[0]

        return notes
    },
    isPreview: (state) => {
        return state.isPreview
    }
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
}
